/* Local tire add-ons. No cart mutations; prices remain Shopify variant prices. */
(function (root) {
  'use strict';
  function installationSku(diameter) {
    if (!Number.isInteger(diameter) || diameter <= 0) return null;
    if (diameter <= 18) return 'DFW-INSTALL-1-18';
    if (diameter <= 24) return 'DFW-INSTALL-1-24';
    return null;
  }
  function cartError(cart) {
    var items = cart.items || [];
    var totals = {};
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!/^DFW-(INSTALL-(1|4)-(18|24)|DISPOSAL-1)$/.test(item.sku || '')) continue;
      var parentKey = item.parent_relationship && item.parent_relationship.parent_key;
      var parent = items.find(function (line) { return line.key === parentKey; });
      if (!parent || !parent.properties || parent.properties._aw_local_tire !== 'true' || !item.properties || item.properties._aw_local_group !== parent.properties._aw_local_group) {
        return 'Please remove the unlinked Denton service and select it again on your tire page.';
      }
      var count = totals[parentKey] || (totals[parentKey] = { installation: 0, disposal: 0, parent: parent, hasInstallation: false });
      if (item.sku === 'DFW-DISPOSAL-1') {
        count.disposal += item.quantity;
        if (count.disposal > parent.quantity) return 'Your tire quantity changed. Reduce old-tire disposal to the number of tires you are replacing, or remove that service.';
      } else {
        var legacyPackage = item.sku.indexOf('DFW-INSTALL-4-') === 0;
        var expectedSku = installationSku(Number(parent.properties._aw_diameter));
        if (legacyPackage && expectedSku) expectedSku = expectedSku.replace('-1-', '-4-');
        if (item.sku !== expectedSku || (legacyPackage && parent.quantity !== 4)) {
          return 'Your installation does not match these tires. Remove the service and select it again on your tire page.';
        }
        count.hasInstallation = true;
        count.installation += item.quantity * (legacyPackage ? 4 : 1);
      }
    }
    for (var key in totals) {
      var total = totals[key];
      if (total.hasInstallation && total.installation > total.parent.quantity) {
        return 'Your tire quantity changed. Reduce installation to the number of tires you want installed, or remove the service and select it again on your tire page.';
      }
    }
    return '';
  }
  var api = { installationSku: installationSku, cartError: cartError };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AWLocalTireServices = api;
})(typeof window === 'undefined' ? globalThis : window);
